"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderUnfilteredLineageCounts = exports.renderFilteredLineageCounts = void 0;
var react_1 = __importDefault(require("react"));
var renderQueryResult_1 = require("../renderQueryResult");
var LineageCountsCacher_1 = require("./LineageCountsCacher");
/**
 * Given a raw query result for a filtered lineage counts query,
 * checks for errors and loading state, and renders the given children accordingly.
 * If there are errors, no children are rendered and the error is logged to the console.
 * If the query is still loading, the children are rendered with cached counts objects.
 * If the query is complete, the children are rendered with new counts objects and the cache is populated.
 * @param result The raw query result for a filtered lineage counts query.
 * @param createUnfilteredCounts Creates an unfiltered counts object from the result data.
 * @param createFilteredCounts Creates a filtered counts object from the result data.
 * @param renderChildren The children to render with the new or cached counts objects.
 */
function renderFilteredLineageCounts(result, createUnfilteredCounts, createFilteredCounts, renderChildren) {
    return (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderLoading: function () { return (react_1.default.createElement(LineageCountsCacher_1.LineageCountsCacher, { countsLoading: true }, renderChildren)); },
            renderData: function (data) { return (react_1.default.createElement(LineageCountsCacher_1.LineageCountsCacher, { countsLoading: false, newUnfilteredCounts: createUnfilteredCounts(data), newFilteredCounts: createFilteredCounts(data) }, renderChildren)); },
        } }));
}
exports.renderFilteredLineageCounts = renderFilteredLineageCounts;
/**
 * Given a raw query result for an unfiltered lineage counts query,
 * checks for errors and loading state, and renders the given children accordingly.
 * If there are errors, no children are rendered and the error is logged to the console.
 * If the query is still loading, the children are rendered with a cached unfiltered counts object.
 * If the query is complete, the children are rendered with a new unfiltered counts object and the cache is populated.
 * Because the query is for unfiltered counts, the children are always rendered with a null filtered counts object.
 * @param result The raw query result for an unfiltered lineage counts query.
 * @param createUnfilteredCounts Creates an unfiltered counts object from the result data.
 * @param renderChildren The children to render with the new or cached counts objects.
 */
function renderUnfilteredLineageCounts(result, createUnfilteredCounts, renderChildren) {
    return (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderLoading: function () { return (react_1.default.createElement(LineageCountsCacher_1.LineageCountsCacher, { countsLoading: true, newFilteredCounts: null }, renderChildren)); },
            renderData: function (data) { return (react_1.default.createElement(LineageCountsCacher_1.LineageCountsCacher, { countsLoading: false, newUnfilteredCounts: createUnfilteredCounts(data), newFilteredCounts: null }, renderChildren)); },
        } }));
}
exports.renderUnfilteredLineageCounts = renderUnfilteredLineageCounts;
//# sourceMappingURL=LineageCountsFunctions.js.map